// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popperTipBox {\n  max-width: 37.5rem;\n  max-height: 31.25rem;\n  overflow-y: auto;\n}\n.popperTipBox::-webkit-scrollbar {\n  width: 0.375rem;\n  height: 0.375rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
